if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

     
         const mainProductVariantId = formData.get('id');
          const mainProductQuantity = formData.get('quantity') || 1;
         const sellingPlanId = formData.get('selling_plan');
         const product_id = formData.get('product-id');
         

             const freeVariantIds = window.freeGifts?.[mainProductVariantId] || [];
             const oneTimeGifts = window.ontimefreeGifts || [];
        if (freeVariantIds.length && sellingPlanId && !window.customerAlreadyReceivedGift) {

          Promise.all(freeVariantIds.map(id => isFreeProductInCart(id)))
             .then(async (results) => {
             let shouldAddGift = true;
             let currentGiftCount = 0;
              try {

                const cart = await fetch('/cart.js').then(r => r.json());

                 console.log(cart,"--results--");

                

                const turboflexProduct = await fetch('/products/turboflex.js')
                  .then(res => res.json());

                const turboflexVariants = turboflexProduct.variants;

                 currentGiftCount = Math.max(
                ...freeVariantIds.map(id => {
                  const variant = turboflexVariants.find(v => v.id == id);

                  if (!variant) return 0;

                  const match = variant.title.match(/\d+/);

                  return match ? Number(match[0]) : 0;
                })
              );

              const existingGift = cart.items.find(item =>
                  item.handle === "turboflex" &&
                  item.properties?._free_gift === "true"
                );
                 
                // const existingCount = existingGift
                //   ? parseInt(existingGift.variant_title, 10)
                //   : 0;

                  const existingCount = existingGift
                  ? Number(existingGift.variant_title.match(/\d+/)?.[0] || 0)
                  : 0;

                  console.log(existingCount,"---existingCount---",currentGiftCount);

              if (currentGiftCount > existingCount) {
                console.log("old gift remove,new gift add ")
                   let updates = {};

                cart.items.forEach(item => {
                  if (
                    item.properties?._free_gift === 'true' &&
                    item.handle === 'turboflex'
                  ) {
                    updates[item.key] = 0;
                  }
                });

                if (Object.keys(updates).length > 0) {
                  await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                  });
                }

                console.log('old turboflex removed');
                 shouldAddGift = true;
                } else {
                  console.log("existing high gift");
                   shouldAddGift = false;                 
                }

               

               
              } catch (err) {
                console.error('Gift Error:', err);
              }
              console.log(currentGiftCount,"---currentGiftCount");
              const newFormData = new FormData();

              // main product
              newFormData.append('items[0][id]', mainProductVariantId);
              newFormData.append('items[0][quantity]', mainProductQuantity);

              if (sellingPlanId) {
                newFormData.append('items[0][selling_plan]', sellingPlanId);
              }
              newFormData.append('items[0][properties][_gift_id]', 'freegift_'+mainProductVariantId);
              newFormData.append('items[0][properties][_main_product]', 'main_'+product_id); 
              newFormData.append('items[0][properties][_gifts_product]', 'allgift_'+product_id);   
              // gifts 
              let giftIndex = 1;

              freeVariantIds.forEach((id, index) => {
                if (!results[index] && shouldAddGift || !results[index] && currentGiftCount == 0) {
                  newFormData.append(`items[${giftIndex}][id]`, id);
                  newFormData.append(`items[${giftIndex}][quantity]`, 1);
                  newFormData.append(`items[${giftIndex}][properties][_free_gift]`, 'true');
                  newFormData.append(`items[${giftIndex}][properties][_gift_id]`, 'freegift_'+mainProductVariantId);
                  newFormData.append(`items[${giftIndex}][properties][_gifts_product]`, 'allgift_'+product_id);
                  giftIndex++;
                }
              });

              // sections 
              if (this.cart) {
                newFormData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                newFormData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }

              // SAME API as normal flow
              fetch(`${routes.cart_add_url}`, {
                method: 'POST',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Accept': 'application/json'
                },
                body: newFormData
              })
                .then((response) => response.json())
                .then((response) => {
                  console.log(response, "--gift-fixed-response--");

                  if (response.errors) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: mainProductVariantId,
                      errors: response.errors || response.description,
                      message: response.message,
                    });

                    this.handleErrorMessage(
                      response.errors || response.description || response.message
                    );
                    this.submitButton.classList.remove('loading');
                    this.submitButton.removeAttribute('aria-disabled');
                    this.error = true;
                    return;
                  }

                  this.error = false;

                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove('loading');

                  if (this.cart && this.cart.classList.contains('is-empty')) {
                    this.cart.classList.remove('is-empty');
                  }

                  if (!this.error) {
                    this.submitButton.removeAttribute('aria-disabled');
                  }

                  this.querySelector('.loading__spinner').classList.add('hidden');
                });

            });

        }else if(!sellingPlanId && oneTimeGifts.length  && !window.customerAlreadyReceivedGift) {
           Promise.all(
              oneTimeGifts.map(id => onetimeFreeProductInCart(id))
          ).then((results) => {

                 const newFormData = new FormData();

              // main product
              newFormData.append('items[0][id]', mainProductVariantId);
              newFormData.append('items[0][quantity]', mainProductQuantity);
              newFormData.append('items[0][properties][_gift_id]', 'freegift_'+mainProductVariantId);
              newFormData.append('items[0][properties][_main_product]', 'main_'+product_id); 
              newFormData.append('items[0][properties][_gifts_product]', 'allgift_'+product_id);   
              // gifts 
              let giftIndex = 1;

              oneTimeGifts.forEach((id, index) => {
                if (!results[index]) {
                  newFormData.append(`items[${giftIndex}][id]`, id);
                  newFormData.append(`items[${giftIndex}][quantity]`, 1);
                  newFormData.append(`items[${giftIndex}][properties][_free_gift]`, 'true');
                  newFormData.append(`items[${giftIndex}][properties][_gift_id]`, 'freegift_'+mainProductVariantId);
                  newFormData.append(`items[${giftIndex}][properties][_gifts_product]`, 'allgift_'+product_id);
                  giftIndex++;
                }
              });

              // sections 
              if (this.cart) {
                newFormData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                newFormData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }

              // SAME API as normal flow
              fetch(`${routes.cart_add_url}`, {
                method: 'POST',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Accept': 'application/json'
                },
                body: newFormData
              })
                .then((response) => response.json())
                .then((response) => {
                  console.log(response, "--gift-fixed-response--");

                  if (response.errors) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: mainProductVariantId,
                      errors: response.errors || response.description,
                      message: response.message,
                    });

                    this.handleErrorMessage(
                      response.errors || response.description || response.message
                    );
                    this.submitButton.classList.remove('loading');
                    this.submitButton.removeAttribute('aria-disabled');
                    this.error = true;
                    return;
                  }

                  this.error = false;

                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove('loading');

                  if (this.cart && this.cart.classList.contains('is-empty')) {
                    this.cart.classList.remove('is-empty');
                  }

                  if (!this.error) {
                    this.submitButton.removeAttribute('aria-disabled');
                  }

                  this.querySelector('.loading__spinner').classList.add('hidden');
                });



          });


        }
        else{

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response,"--response-2--",response.status);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          //this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
        console.log("ssss===");
      }
    }
  );
}
async function isFreeProductInCart(variantId,productId) {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items.some(item => item.id == variantId);
    //  return cart.items.some(item =>

    //   item.id == variantId &&
    //   item.properties?._gifts_product === 'allgift_' + productId

    // );
  } catch (e) {
    console.error("Cart check error:", e);
    return false;
  }
}

async function onetimeFreeProductInCart(variantId) {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    return cart.items.some(item =>
      item.id == variantId &&
      item.properties?._free_gift === 'true'
    );
  } catch (e) {
    console.error(e);
    return false;
  }
}
function getTurboFlexCount(item) {
    return parseInt(item.variant_title, 10) || 0;
}